import {
    OUTREACH_DASHBOARD_ACCESS,
  OUTREACH_SELLER_ACCESS,
  NICHE_ACCESS,
  APPROVE_FOR_NICHE_ACCESS,
  OUTREACH_INVOICE_ACCESS,
  BACK_LINK_ACCESS,
  SITE_LIST_ACCESS,
  OUTREACH_LOGS_ACCESS,
} from "@/helpers/permissionsConstant";

export default [
  {
    title: "Outreach",
    icon: "Link2Icon",
    gate: [OUTREACH_DASHBOARD_ACCESS, OUTREACH_SELLER_ACCESS, NICHE_ACCESS, APPROVE_FOR_NICHE_ACCESS, BACK_LINK_ACCESS, SITE_LIST_ACCESS, OUTREACH_INVOICE_ACCESS ],
    class: "payroll-tour",
    children: [
      {
        title: "Dashboard",
        route: "outreach-dashboard",
        gate: OUTREACH_DASHBOARD_ACCESS,
      },
      {
        title: "Seller",
        route: "outreach-seller",
        gate: OUTREACH_SELLER_ACCESS,
      },
      {
        title: "Niche",
        route: "outreach-niche",
        gate: NICHE_ACCESS,
      },
      {
        title: "Approve For Niche",
        route: "outreach-approvefor-niche",
        gate: APPROVE_FOR_NICHE_ACCESS,
      },
      {
        title: "Site List",
        route: "site-list",
        gate: SITE_LIST_ACCESS,
      },
      {
        title: "Backlinks",
        route: "back-link",
        gate: BACK_LINK_ACCESS,
      },
      {
        title: "Invoice",
        route: "outreach-invoice-list",
        gate: OUTREACH_INVOICE_ACCESS,
      },
      // {
      //   title: "Outreach Logs",
      //   route: "outreach-logs",
      //   gate: OUTREACH_LOGS_ACCESS,
      // },
    ],
  },
];
